import React from "react";
import { connect } from "react-redux";
import {
    Server,
    ClipboardCheck,
    Hash,
    MapPin,
    Shield,
    Calendar,
    User,
    // Box
} from "lucide-react";
import { formatReportDate } from "../../../src/utils";

function GeneralInfoSection({ deviceTypes, locations, compliance, sectors, rule, username, msbList }) {


    function getTargetTypeInfoString(elements) {
        if (!elements.length) {
            return ' - '
        }
        return elements.map(el => el.name).join(', ');
    }

    return (
        <div className="addrules-info-card-v2">
            <h4 className="info-card-title">Additional Info</h4>
            <div className="info-card-list">

                {/* MSB */}
                {/* <div className="addrules-info-item-v2">
                    <Box />
                    <div className="info-content">
                        <span className="info-label">msb</span>
                        <span className="info-value">{getTargetTypeInfoString(msbList)}</span>
                    </div>
                </div> */}

                {/* Device Types */}
                <div className="addrules-info-item-v2">
                    <Server />
                    <div className="info-content">
                        <span className="info-label">device types</span>
                        <span className="info-value">{getTargetTypeInfoString(deviceTypes)}</span>
                    </div>
                </div>

                {/* Compliance */}
                <div className="addrules-info-item-v2">
                    <ClipboardCheck />
                    <div className="info-content">
                        <span className="info-label">compliance</span>
                        <span className="info-value">{getTargetTypeInfoString(compliance)}</span>
                    </div>
                </div>

                {/* Version */}
                <div className="addrules-info-item-v2">
                    <Hash />
                    <div className="info-content">
                        <span className="info-label">version</span>
                        <span className="info-value">{rule.version || ' - '}</span>
                    </div>
                </div>

                <div className="addrules-divider-v2"></div>

                {/* Locations */}
                <div className="addrules-info-item-v2">
                    <MapPin />
                    <div className="info-content">
                        <span className="info-label">locations</span>
                        <span className="info-value">{getTargetTypeInfoString(locations)}</span>
                    </div>
                </div>

                {/* Sectors */}
                <div className="addrules-info-item-v2">
                    <Shield />
                    <div className="info-content">
                        <span className="info-label">sections</span>
                        <span className="info-value">{getTargetTypeInfoString(sectors)}</span>
                    </div>
                </div>

                {/* Creation Date */}
                <div className="addrules-info-item-v2">
                    <Calendar />
                    <div className="info-content">
                        <span className="info-label">creation date</span>
                        <span className="info-value">{rule.createdOn ? formatReportDate(rule.createdOn) : ' - '}</span>
                    </div>
                </div>

                {/* Modified Date */}
                <div className="addrules-info-item-v2">
                    <Calendar />
                    <div className="info-content">
                        <span className="info-label">modified date</span>
                        <span className="info-value">{rule.updatedOn ? formatReportDate(rule.updatedOn) : ' - '}</span>
                    </div>
                </div>

                {/* Author */}
                <div className="addrules-info-item-v2">
                    <User />
                    <div className="info-content">
                        <span className="info-label">author</span>
                        <span className="info-value">{username || ' - '}</span>
                    </div>
                </div>

            </div>
        </div>
    )
}

function mapStateToProps(state) {

    const rule = state.addRulesPage.rule || {};

    const deviceTypes = rule.deviceTypes || [];
    const locations = rule.locations || [];
    const compliance = rule.compliance || [];
    const sectors = rule.sectors || [];
    const msbList = rule.msbList || [];

    const auth = state.auth;

    const username = rule.user || auth.username;

    return { deviceTypes, locations, compliance, sectors, msbList, username, rule };

}

export default connect(mapStateToProps)(GeneralInfoSection);
